<template>
  <div class="">
    <img src="../assets/img/icon_login_top_bg.png" alt="" style="height: 150px;width: 100%;">
    <div class="tastek-login-title" style="padding: 10px;">
      <img src="../assets/img/icon_login_logo.png" alt="" style="width: 90%;margin: 30px 0px;">
    </div>
    <div class="tastek-login-form">
      <div class="layui-form layui-form-pane">
        <div class="layui-form-item tastek-form-item">
          <div class="layui-input-block" style="margin: 0;display: flex;justify-content: center;">
            <label style="margin-right: 8px;font-size: 18px;font-weight: bold;line-height: 36px;">账号</label>
            <input type="text" name="username" v-model="loginForm.username" placeholder="请输入账号" class="layui-input"
                   style="width: calc(100% - 170px);">
          </div>
        </div>
        <div class="layui-form-item tastek-form-item">
          <div class="layui-input-block" style="margin: 0;display: flex;justify-content: center;">
            <label style="margin-right: 8px;font-size: 18px;font-weight: bold;line-height: 36px;">密码</label>
            <input @on-change="loginForm.password" name="password" type="password"
                   v-model="loginForm.password" placeholder="请输入密码"
                   class="layui-input" style="width: calc(100% - 170px);">
          </div>
        </div>
        <button class="layui-btn tastek-login-btn btn-login" id="loginBtn" @click="login"
                style="width: 150px;border-radius: 10px;background-color: #00a761;">确认
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../assets/layui/css/layui.css';
</style>

<script>
import {getUUID} from "@/utils";

export default {
  name: "login_wx",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        code: '',
      }
    }
  },
  created() {
    this.loginForm.code = this.getUrlCode()
  },
  methods: {
    //绑定用户名 密码登录
    login() {
      if (!this.loginForm.code) {
        this.$message.warning("微信授权code不能为空！");
        return
      }
      if (!this.loginForm.username) {
        this.$message.warning("账号不能为空！");
        return
      }
      if (!this.loginForm.password) {
        this.$message.warning("密码不能为空！");
        return
      }

      this.$http({
        url: this.$http.adornUrl("/api/wechat/bind"),
        method: "post",
        data: this.$http.adornData(this.loginForm),
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 截取url中的code方法 ,this.$route.query.code是获取不到code的，需要截取
    getUrlCode() {
      //http://test.szwandi.cn/iot/?code=093YDkFa1wU6MB0I80Ja1lwq8F3YDkFR&state=#/login_wx
      let url = location.href
      if (url.indexOf("?") !== -1) {
        try {
          let obj = url.split("&")[0].split("=")[1]
          return obj
        } catch (e) {
          this.$message.error("code解析异常");
          console.log("code解析异常！", url)
          return null
        }
      }
      return null
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/pages/login_wx.vue